import { oz } from '@weft/utils';
import { EventFieldSchema } from './event-field-schema';
import { EVENT_FIELD_TYPES } from './event-field-type-schema';

export const EnumEventFieldSchema = EventFieldSchema.extend({
  type: oz.literal(EVENT_FIELD_TYPES.Enum),
  values: oz.array(oz.string()).default([]),
}).openapi('EnumDataField');

export type EnumEventField = oz.infer<typeof EnumEventFieldSchema>;